import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const OnsitePickerPage = lazy(() => import('~/features/onboarding/pages/onsite-picker-page'));

/** Onsite sub-picker — Item Setup + Product Copy, reached from the Onsite card on /onboarding. */
export const Route = createFileRoute('/_authenticated/_tenant/onboarding/onsite')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <OnsitePickerPage />
    </Suspense>
  ),
});
